/*
 * WKS quick-add — winkelwagenknop op de productkaarten zonder herladen.
 *
 * Was: <a href="/cart/add?id=..."> = volledige paginanavigatie (add + redirect +
 * hele collectiepagina opnieuw laden, ~1,5 tot 4 sec, en de bezoeker verliest
 * zijn plek in het raster).
 * Nu: POST naar /cart/add.js, teller in de header bijwerken, korte bevestiging.
 *
 * De href blijft staan als fallback: zonder JS (of bij een netwerkfout) werkt de
 * knop precies zoals vroeger.
 */
(function () {
  'use strict';

  var SELECTOR = 'a.wks-cart-btn';
  var DONE_MS = 1500;   // hoe lang het vinkje op de knop blijft staan
  var TOAST_MS = 4500;  // hoe lang de bevestiging onderin blijft staan

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  if (root.charAt(root.length - 1) !== '/') root += '/';

  var toastEl = null;
  var toastTimer = null;

  /* ---------------------------------------------------------------- styles */

  function injectStyles() {
    if (document.getElementById('wks-quick-add-css')) return;
    var css = [
      '.wks-cart-btn{position:relative}',
      '.wks-cart-btn.is-busy,.wks-cart-btn.is-done{pointer-events:none}',
      '.wks-cart-btn.is-busy svg,.wks-cart-btn.is-done svg,.wks-cart-btn.is-error svg{opacity:0}',
      '.wks-cart-btn.is-busy::after{content:"";position:absolute;width:16px;height:16px;border:2px solid rgba(255,255,255,.45);border-top-color:#fff;border-radius:50%;animation:wks-qa-spin .6s linear infinite}',
      '.wks-cart-btn.is-done::after{content:"\\2713";position:absolute;font-size:19px;line-height:1;font-weight:700;color:#fff}',
      '.wks-cart-btn.is-error{background:#C0392B;border-color:#C0392B}',
      '.wks-cart-btn.is-error::after{content:"!";position:absolute;font-size:18px;line-height:1;font-weight:700;color:#fff}',
      '@keyframes wks-qa-spin{to{transform:rotate(360deg)}}',
      '.cart-count-bubble.wks-qa-bump{animation:wks-qa-bump .45s ease}',
      '@keyframes wks-qa-bump{0%{transform:scale(1)}35%{transform:scale(1.35)}100%{transform:scale(1)}}',
      '.wks-qa-toast{position:fixed;right:20px;bottom:20px;z-index:100000;display:flex;align-items:center;gap:10px;max-width:min(360px,calc(100vw - 32px));padding:12px 14px;background:#fff;color:#222;border:1px solid #E0E0E0;border-left:4px solid #2BB14A;box-shadow:0 6px 24px rgba(0,0,0,.14);font-size:13px;line-height:1.35;opacity:0;transform:translateY(12px);transition:opacity .22s ease,transform .22s ease}',
      '.wks-qa-toast.is-visible{opacity:1;transform:translateY(0)}',
      '.wks-qa-toast.is-error{border-left-color:#C0392B}',
      '.wks-qa-toast__body{flex:1;min-width:0}',
      '.wks-qa-toast__title{display:block;font-weight:600}',
      '.wks-qa-toast__name{display:block;color:#767676;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}',
      '.wks-qa-toast__link{flex:none;color:#2BB14A;font-weight:600;text-decoration:underline;white-space:nowrap}',
      '.wks-qa-toast__close{flex:none;border:0;background:none;padding:0 2px;font-size:18px;line-height:1;color:#767676;cursor:pointer}',
      '@media (max-width:767px){.wks-qa-toast{right:12px;left:12px;bottom:14px;max-width:none}}',
      '@media (prefers-reduced-motion:reduce){.wks-qa-toast{transition:none}.cart-count-bubble.wks-qa-bump{animation:none}.wks-cart-btn.is-busy::after{animation:none}}'
    ].join('');
    var style = document.createElement('style');
    style.id = 'wks-quick-add-css';
    style.textContent = css;
    document.head.appendChild(style);
  }

  /* ------------------------------------------------------------ header-teller */

  function paintCount(count) {
    var big = window.cartStrings && window.cartStrings.item_99;
    var text = count > 99 && big ? big : String(count);
    var nodes = document.querySelectorAll('[data-cart-count]');
    for (var i = 0; i < nodes.length; i++) nodes[i].textContent = text;

    var one = (window.cartStrings && window.cartStrings.item) || 'item';
    var many = (window.cartStrings && window.cartStrings.items) || 'artikelen';
    var labels = document.querySelectorAll('.cart-count-bubble .visually-hidden');
    for (var j = 0; j < labels.length; j++) {
      labels[j].textContent = count + ' ' + (count === 1 ? one : many);
    }

    var bubbles = document.querySelectorAll('.cart-count-bubble');
    for (var k = 0; k < bubbles.length; k++) {
      bubbles[k].classList.remove('wks-qa-bump');
      void bubbles[k].offsetWidth; // reflow forceren zodat de animatie opnieuw start
      bubbles[k].classList.add('wks-qa-bump');
    }
  }

  function currentCount() {
    var node = document.querySelector('[data-cart-count]');
    if (!node) return null;
    var n = parseInt((node.textContent || '').replace(/\D/g, ''), 10);
    return isNaN(n) ? null : n;
  }

  /* Meteen ophogen bij de klik, zodat de teller direct meespringt. Daarna
     rekent refreshCount() het echte aantal na. */
  function bumpCount(delta) {
    var now = currentCount();
    if (now === null) return;
    paintCount(now + delta);
  }

  function refreshCount() {
    fetch(root + 'cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { paintCount(cart.item_count); })
      .catch(function () { /* teller niet kunnen bijwerken is niet fataal */ });
  }

  /* -------------------------------------------------------------------- toast */

  function buildToast() {
    var el = document.createElement('div');
    el.className = 'wks-qa-toast';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    el.innerHTML =
      '<div class="wks-qa-toast__body">' +
        '<span class="wks-qa-toast__title"></span>' +
        '<span class="wks-qa-toast__name"></span>' +
      '</div>' +
      '<a class="wks-qa-toast__link" href="' + root + 'cart">Bekijk winkelwagen</a>' +
      '<button type="button" class="wks-qa-toast__close" aria-label="Sluiten">&times;</button>';
    el.querySelector('.wks-qa-toast__close').addEventListener('click', hideToast);
    document.body.appendChild(el);
    return el;
  }

  function hideToast() {
    if (!toastEl) return;
    clearTimeout(toastTimer);
    toastEl.classList.remove('is-visible');
  }

  function showToast(title, name, link, isError) {
    if (!toastEl) toastEl = buildToast();
    toastEl.classList.toggle('is-error', !!isError);
    toastEl.querySelector('.wks-qa-toast__title').textContent = title;
    toastEl.querySelector('.wks-qa-toast__name').textContent = name || '';
    var a = toastEl.querySelector('.wks-qa-toast__link');
    a.textContent = link.text;
    a.setAttribute('href', link.href);
    void toastEl.offsetWidth;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, TOAST_MS);
  }

  /* ------------------------------------------------------------------ helpers */

  function variantIdFrom(link) {
    var m = /[?&]id=(\d+)/.exec(link.getAttribute('href') || '');
    return m ? m[1] : null;
  }

  function productInfoFor(link) {
    var card = link.closest('.product-item') || link.closest('li.product');
    var info = { name: '', url: root };
    if (!card) return info;
    var title = card.querySelector('[data-product-title]');
    if (title) {
      info.name = title.getAttribute('data-product-title') || title.textContent.trim();
      info.url = title.getAttribute('data-product-url') || title.getAttribute('href') || info.url;
    } else {
      var fallback = card.querySelector('.card-title');
      if (fallback) {
        info.name = fallback.textContent.trim();
        info.url = fallback.getAttribute('href') || info.url;
      }
    }
    return info;
  }

  function setState(link, state) {
    link.classList.remove('is-busy', 'is-done', 'is-error');
    if (state) link.classList.add(state);
  }

  /* -------------------------------------------------------------------- klik */

  function onClick(e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var link = e.target && e.target.closest ? e.target.closest(SELECTOR) : null;
    if (!link) return;

    var variantId = variantIdFrom(link);
    if (!variantId) return; // geen id in de href: laat de browser het gewoon doen

    e.preventDefault();
    if (link.classList.contains('is-busy')) return;

    var href = link.href;
    var info = productInfoFor(link);
    setState(link, 'is-busy');
    bumpCount(1);

    fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          // Shopify weigert de regel (zeldzaam). Klant een Nederlandse melding
          // geven en doorverwijzen naar de productpagina; de ruwe reden alleen
          // in de console voor onszelf.
          if (window.console && result.data) {
            console.warn('[wks-quick-add]', result.data.description || result.data.message || result.data);
          }
          setState(link, 'is-error');
          showToast('Kon niet worden toegevoegd', info.name, { text: 'Bekijk product', href: info.url }, true);
          refreshCount(); // de alvast opgehoogde teller weer rechtzetten
          setTimeout(function () { setState(link, null); }, DONE_MS);
          return;
        }
        setState(link, 'is-done');
        showToast('Toegevoegd aan je winkelwagen', info.name, { text: 'Bekijk winkelwagen', href: root + 'cart' }, false);
        refreshCount();
        setTimeout(function () { setState(link, null); }, DONE_MS);
      })
      .catch(function () {
        // Netwerkfout: terugvallen op het oude gedrag zodat de klant nooit vastloopt.
        window.location.href = href;
      });
  }

  function init() {
    injectStyles();
    document.addEventListener('click', onClick, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
